import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import useDmsPalette from '../hooks/useDmsPalette';

export default function UploadZone({ onFileDrop, multiple = false }) {
  const MP = useDmsPalette();
  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles.length > 0) {
      multiple ? onFileDrop(acceptedFiles) : onFileDrop(acceptedFiles[0]);
    }
  }, [onFileDrop, multiple]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: `2px dashed ${isDragActive ? MP.blue : MP.border}`,
        borderRadius: 2,
        p: 4,
        textAlign: 'center',
        cursor: 'pointer',
        bgcolor: isDragActive ? `${MP.blue}10` : 'transparent',
        transition: 'all 0.2s',
        '&:hover': { borderColor: MP.blue, bgcolor: `${MP.blue}10` },
      }}
    >
      <input {...getInputProps()} />
      <CloudUploadIcon sx={{ fontSize: 48, color: isDragActive ? MP.blue : MP.textSecondary, mb: 1 }} />
      <Typography variant="body1" fontWeight={600}>
        {isDragActive ? 'Drop files here' : 'Drag & drop files, or click to browse'}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        PDF, DOCX, TXT, images — max 50MB
      </Typography>
    </Box>
  );
}
